module.exports = __webpack_public_path__ + "static/media/Why-three.d3147dad.svg";